import { gql } from '@apollo/client';
import { VersionHistoryFields } from 'ants/query';

export const CmsPageCreateHintQuery = gql`
query CmsPageCreateHintQuery($name: String!) {
  cms_page_create_hint(name: $name) {
    name
    similar_items {
      resource {
        account
        key
        hashkey: _hashkey
      }
      page {
        name
        internal_name
        slug
        parent { hashkey: _hashkey }
      }
    }
    key_suggestions
  }
}
`;

export const CmsPageCreateMutation = gql`
mutation CmsPageCreate(
  $page: CmsPagePageInput!,
  $key: String,
) {
  cms_page_create(
    page: $page,
    key: $key) {
      status {
      okay
      errors {
        msg
        field_path
        code
      }
      key
    }
    key_suggestions
  }
}
`;

export const CmsPageReadQuery = gql`
fragment DivData on ContentDiv {
  
  raw
  raw_type
  data
  source_type

  resource_cls
  resource_key
  resource_view_cls

  structure { account, key, hashkey: _hashkey }
  structure_content { account, structure, key, hashkey: _hashkey }
  structure_data

  tag_name
  class_name
  key

  attrs
}
query CmsPageReadQuery($resource: CmsPageInput!, $withHistory: Boolean) {
  cms_page_read(resource: $resource, with_history: $withHistory) {
    item {
      resource {
        account
        key
        hashkey: _hashkey
      }
      page {
        name
        internal_name
        slug
        parent { hashkey: _hashkey }
        base_page { hashkey: _hashkey }
        custom_config
      }
      config {
        slug
        default_status_code
        base_page { hashkey: _hashkey }
      }
      body {
        body_content_type

        by_structure { account, key, hashkey: _hashkey }
        by_structure_content { account, structure, key, hashkey: _hashkey }
        by_structure_data

        content {
          ...DivData
          # https://github.com/graphql/graphql-spec/issues/91
          # Level 1
          children {
            ...DivData

            # Level 2
            children {
              ...DivData

              # Level 3
              children {
                ...DivData

                # Level 4
                children {
                  ...DivData

                  # Level 5
                  children {
                    ...DivData
                  }
                }
              }
            }
          }
        }
        body_scripts
        footer_scripts
      }
    }
    history {
      ${VersionHistoryFields}
    }
  }
}
`;

export const CmsPageUpdateMutation = gql`
mutation CmsPageUpdateMutation(
  $resource: CmsPageInput!,
  $page: CmsPagePageInput!,
  $body: CmsPageBodyInput!,
  $version: RecordStage
) {
  cms_page_update(
    resource: $resource,
    page: $page,
    body: $body,
    version: $version,
  ) {
    status {
      okay
      errors {
        msg
        field_path
        code
      }
      key
    }
  }
}
`;

export const CmsPageDeleteMutation = gql`
mutation  CmsPageDeleteMutation(
  $resource: CmsPageInput!,
  $name: String!) {
  cms_page_delete(resource: $resource, name: $name) {
    status {
      okay
      errors { msg, field_path, code}
      key
    }
  }
}
`;

export const CmsPageSearchQuery = gql`
query CmsPageSearchQuery($search: String!, $page: PagedRequestInput) {
  cms_page_search(search: $search, page: $page) {
    items {
      resource {
        account
        key
        hashkey: _hashkey
      }
      page {
        name
        internal_name
        slug
        parent { hashkey: _hashkey }
      }
    }
    page {
      next_page_key
      count
      prev_page_key
    }
  }
}
`;

export const CmsPageNameQuery = gql`
query CmsPageNameQuery($resource: CmsPageInput!) {
  cms_page_name(resource: $resource) {
    name
    internal_name
    slug
    parent { hashkey: _hashkey }
  }
}
`;
